'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import n from "../../external/classnames/index.js";
import { useState as u } from "react";
import l from "./form.module.scss.js";
const x = ({ id: a, name: r, disabled: t, label: s, ...i }) => /* @__PURE__ */ e.jsx("div", { className: l["field-container"], children: /* @__PURE__ */ e.jsxs("div", { className: l["radio-container"], children: [
  /* @__PURE__ */ e.jsx(
    "input",
    {
      type: "radio",
      id: a,
      name: r,
      disabled: t,
      ...i
    }
  ),
  s ? /* @__PURE__ */ e.jsx(
    "div",
    {
      className: l["label-container"],
      "data-disabled": t,
      children: /* @__PURE__ */ e.jsx("label", { htmlFor: a, children: s })
    }
  ) : null
] }) }), v = ({
  className: a,
  options: r,
  name: t,
  onChange: s
}) => {
  const [i, d] = u(r[0].value);
  return /* @__PURE__ */ e.jsx("fieldset", { className: n(l["radio-group"], a), children: r.map((c, m) => /* @__PURE__ */ e.jsx(
    x,
    {
      name: t,
      checked: i === c.value,
      onChange: (o) => {
        d(o.target.value), s && s(o);
      },
      ...c
    },
    m
  )) });
};
export {
  v as RadioGroup,
  x as default
};
